import { Skeleton } from '@/components/ui'

import { LeadsRepresadosFiltrosSkeleton } from './ui/filtros-lead-represado'
import { ListaLeadsRepresadosSkeleton } from './ui/lista-leads-represados-skeleton'

export const ConsultaLeadsRepresadosPageSkeleton = () => {
  return (
    <div className="mx-auto min-h-screen w-full sm:max-w-4xl" data-testid="consulta-leads-represados-skeleton">
      <div className="mb-8 h-7">
        <Skeleton className="h-7 w-64" />
      </div>
      <div className="bg-foreground mt-8 pt-6">
        <LeadsRepresadosFiltrosSkeleton />
        <ListaLeadsRepresadosSkeleton />
      </div>
      <div className="bg-foreground divide-y divide-neutral-200 rounded-sm px-6 py-6">
        <Skeleton className="h-10 w-full" />
      </div>
    </div>
  )
}
